import i18n from "../../../public/i18n";

export const TABLE_ROWS_NUMBER = 50;
export const FOLDER_NUMBER = 50;

export const GESTIONE_DOCUMENTI_TABLE_HEADER = () => [
  { id: "name", label: i18n.t("Name"), minWidth: 150 },
  { id: "confidence", label: i18n.t("Status"), minWidth: 100 },
  { id: "createdAt", label: i18n.t("Uploaded"), minWidth: 100 },
  { id: "owner", label: i18n.t("User"), minWidth: 100 },
  { id: "category", label: i18n.t("Category"), minWidth: 100 },
  { id: "notes", label: i18n.t("Notes"), minWidth: 100 },
  { id: "actions", label: i18n.t("Actions"), minWidth: 150 },
];

export const GESTIONE_DOCUMENTI_TABLE_HEADER_USER = () => [
  { id: "name", label: i18n.t("Name"), minWidth: 150 },
  { id: "status", label: i18n.t("Status"), minWidth: 100 },
  { id: "createdAt", label: i18n.t("Uploaded"), minWidth: 100 },
  { id: "date", label: i18n.t("Date"), minWidth: 100 },
  { id: "amount", label: i18n.t("Amount"), minWidth: 100 },
  { id: "category", label: i18n.t("Category"), minWidth: 100 },
  { id: "notes", label: i18n.t("Notes"), minWidth: 100 },
  {
    id: "notesOperator",
    label: i18n.t("Notes") + " " + i18n.t("operator"),
    minWidth: 100,
  },
  { id: "action", label: i18n.t("Actions"), minWidth: 100 },
];

export const GESTIONE_PRATICHE_TABLE_HEADER = () => [
  { id: "name", label: i18n.t("Name"), minWidth: 150 },
  { id: "status", label: i18n.t("Status"), minWidth: 100 },
  { id: "createdAt", label: i18n.t("Created"), minWidth: 100 },
  { id: "username", label: i18n.t("User"), minWidth: 100 },
  { id: "fiscalCodeUser", label: i18n.t("CF"), minWidth: 100 },
  { id: "company", label: i18n.t("Company"), minWidth: 100 },
  { id: "commercialista", label: i18n.t("Operator"), minWidth: 100 },
  { id: "studio", label: i18n.t("Studio"), minWidth: 100 },
  { id: "service", label: i18n.t("Service"), minWidth: 100 },
  { id: "expirationDate", label: i18n.t("PracticeExpiration") },
  { id: "actions", label: i18n.t("Actions"), minWidth: 150 },
];

export const GESTIONE_PRATICHE_TABLE_HEADER_USER = () => [
  { id: "name", label: i18n.t("Name") },
  { id: "status", label: i18n.t("Status") },
  { id: "createdAt", label: i18n.t("Created") },
  { id: "commercialista", label: i18n.t("Operator") },
  { id: "actions", label: i18n.t("Actions") },
];

export const GESTIONE_NEWS_HEADER = () => [
  { id: "image", label: i18n.t("Img"), minWidth: 100 },
  { id: "newsTitle", label: i18n.t("Title"), minWidth: 130 },
  { id: "categoryId", label: i18n.t("Category"), minWidth: 100 },
  { id: "createdAt", label: i18n.t("Created"), minWidth: 110 },
  { id: "date", label: i18n.t("Data"), minWidth: 110 },
  { id: "list", label: i18n.t("List"), minWidth: 160 },
  { id: "text", label: i18n.t("Text"), minWidth: 300 },
  { id: "status", label: i18n.t("Status"), minWidth: 105 },
  { id: "actions", label: i18n.t("Actions"), minWidth: 160 },
];

export const NUCLEO_FAMILIARE = () => [
  { id: "name", label: i18n.t("Name"), minWidth: 300 },
  { id: "cf", label: i18n.t("CF"), minWidth: 100 },
  { id: "actions", label: i18n.t("Actions"), minWidth: 100 },
];
